import { CORE_SEATS_ENTERPRISE, CORE_SEATS_INCLUDED_STARTER, CORE_SEATS_PROFESSIONAL, CORE_SEATS_STARTER, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL } from '../constants/ApiNames';
import * as CurrencyCodes from '../constants/CurrencyCodes';
import * as UpgradeProducts from '../constants/UpgradeProducts';
const currencyCodeValues = Object.values(CurrencyCodes || {});
const upgradeProductValues = Object.values(UpgradeProducts || {});
export const isCurrencyCode = currencyCode => {
  return currencyCodeValues.indexOf(currencyCode) !== -1;
};
export const isUpgradeProduct = upgradeProduct => {
  return upgradeProductValues.indexOf(upgradeProduct) !== -1;
};
export const isQuantityPackDetails = sku => {
  return sku.skuType === 'QUANTITY_PACK';
};
export const isProductVersion = sku => {
  return sku.skuType === 'PRODUCT_VERSION';
};
const SalesServiceProOrEntApiNames = [SALES_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE];
export const isSalesServiceProOrEnt = apiName => {
  return SalesServiceProOrEntApiNames.some(name => name === apiName);
};
const CoreSeatsApiNames = [CORE_SEATS_INCLUDED_STARTER, CORE_SEATS_STARTER, CORE_SEATS_PROFESSIONAL, CORE_SEATS_ENTERPRISE];
export const isCoreSeat = apiName => {
  return CoreSeatsApiNames.some(name => name === apiName);
};